// Labels and display of company-form fields, for the edit-approval diff and history.

export const COSTS = {
  container: 'ຄອນເທັນເນີ',
  fix_cost: 'ທຸລະກິດເປັນຖ້ຽວ',
  chartered: 'ມອບເໝົາ',
  bag: 'ບໍລິມາດ',
  '32km': 'ຫຼັກ32',
  infect: 'ຂີ້ເຫຍື້ອຕິດເຊື້ອ',
};

export const FIELD_LABELS = {
  company_name: 'ຊື່ບໍລິສັດ',
  phone: 'ເບີໂທບໍລິສັດ',
  email: 'Email ບໍລິສັດ',
  status: 'ສະຖານະອອກບິນ',
  can_collect: 'ສະຖານະເກັບ',
  // name / surname / email: no longer in the form; kept for edits approved before.
  coordinator_name: 'ຊື່ຜູ້ປະສານງານ',
  coordinator_surname: 'ນາມສະກຸນຜູ້ປະສານງານ',
  coordinator_phone: 'ເບີໂທຜູ້ປະສານງານ',
  coordinator_email: 'Email ຜູ້ປະສານງານ',
  village_id: 'ບ້ານ',
  village_details: 'ລາຍລະອຽດບ້ານ',
  lat: 'Latitude',
  lng: 'Longitude',
  cost_by: 'ປະເພດບໍລິການ',
  fix_cost: 'ມູນຄ່າສັນຍາ',
  vehicle_types: 'ລາຄາຕາມລົດ',
  expect_trash: 'ຂີ້ເຫຍື້ອຄາດໝາຍ',
  start_date: 'ເລີ່ມວັນທີ',
  favorite_dates: 'ມື້ບໍລິການ',
  collect_description: 'ໝາຍເຫດ',
  images: 'ຮູບພາບ (ຈຳນວນ)',
};

/**
 * @param {string} field
 * @param {*} value a normalised value from the API diff / changes
 * @param {{vehicles?: Object, villages?: Object, village_details?: Object}} names
 *   id → name maps: vehicles from vehicle_type/, the other two from the API's `labels`
 */
export function formatValue(field, value, names = {}) {
  if (value === null || value === undefined || value === '' || (Array.isArray(value) && !value.length)) return '—';
  const nameOf = (map, id) => (map && map[id]) || `#${id}`;
  if (field === 'cost_by') return COSTS[value] || value;
  if (field === 'can_collect') return ['1', 1, true, 'true'].includes(value) ? 'ເກັບໄດ້' : 'ເກັບບໍ່ໄດ້';
  if (field === 'fix_cost') return Number(value).toLocaleString();
  if (field === 'village_id') return nameOf(names.villages, value);
  if (field === 'village_details') return value.map((id) => nameOf(names.village_details, id)).join(', ');
  if (field === 'vehicle_types') {
    return value.map((v) => `${nameOf(names.vehicles, v.id)}: ${Number(v.price).toLocaleString()}`).join(', ');
  }
  if (Array.isArray(value)) return value.join(', ');
  return String(value);
}

/** {field: {old, new}} → rows in form order. */
export function changeRows(changes, names = {}) {
  return Object.keys(FIELD_LABELS)
    .filter((field) => changes && changes[field])
    .map((field) => ({
      field,
      label: FIELD_LABELS[field],
      old: formatValue(field, changes[field].old, names),
      new: formatValue(field, changes[field].new, names),
    }));
}
